// extracted by mini-css-extract-plugin
module.exports = {"ImageWrapper":"styles_ImageWrapper__I9afk","Image_ready":"styles_Image_ready__VYTrr"};